import { Other } from "./other";

export const treatments = [Other];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/other/index.ts